import React from 'react';

const WallOfLoveFormModal = React.lazy(() => import('../components/FormModal'));
const wallOfLoveModalRegistry = {
    crm_wallOfLoveId: WallOfLoveFormModal
};
export default wallOfLoveModalRegistry;
